// extracted by mini-css-extract-plugin
module.exports = {"major":"AlternateAddressIconSmall_major__3fc_m"};